/* Waves redesign behaviour for Flex 7. Vanilla JS, no dependencies. */
(() => {
  "use strict";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Drop deck ---------- */
  function initDeck(root) {
    if (root.__wvDeck) return;
    const tabs = Array.from(root.querySelectorAll(".wv-tab"));
    const panels = Array.from(root.querySelectorAll(".wv-drop"));
    const tabList = root.querySelector(".wv-hero__tabs");
    const pauseBtn = root.querySelector("[data-deck-pause]");
    const counter = root.querySelector("[data-deck-n]");
    if (!tabs.length) return;
    let index = 0;
    const auto = { user: designMode || root.dataset.autoplay === "false", hover: false, focus: false, away: false };
    const allowed = () => !reduce.matches && tabs.length > 1;
    const running = () => allowed() && !auto.user && !auto.hover && !auto.focus && !auto.away;

    function sync() {
      root.classList.toggle("is-auto", allowed() && !auto.user);
      root.classList.toggle("is-paused", !running());
      panels.forEach((p) => p.setAttribute("aria-live", running() ? "off" : "polite"));
      if (pauseBtn) {
        pauseBtn.hidden = !allowed();
        pauseBtn.setAttribute("aria-pressed", String(auto.user));
        pauseBtn.setAttribute("aria-label", auto.user ? "Play drops" : "Pause drops");
        const l = pauseBtn.querySelector(".wv-pause__l"); if (l) l.textContent = auto.user ? "Play" : "Pause";
      }
    }
    function select(i, opts = {}) {
      i = (i + tabs.length) % tabs.length;
      if (opts.manual) { auto.user = true; sync(); }
      if (i === index && !opts.force) return;
      index = i;
      panels.forEach((p, j) => { const on = j === i; p.hidden = !on; p.classList.toggle("is-active", on); });
      tabs.forEach((t, j) => { t.setAttribute("aria-selected", String(j === i)); t.tabIndex = j === i ? 0 : -1; });
      root.style.setProperty("--accent", panels[i].dataset.accent);
      root.style.setProperty("--accent-ink", panels[i].dataset.ink);
      if (counter) counter.textContent = String(i + 1).padStart(2, "0");
      if (tabList.scrollWidth > tabList.clientWidth) tabList.scrollTo({ left: Math.max(0, tabs[i].offsetLeft - 16), behavior: reduce.matches ? "auto" : "smooth" });
      if (opts.focus) tabs[i].focus();
    }

    tabs.forEach((t, i) => t.addEventListener("click", () => select(i, { manual: true })));
    tabList.addEventListener("keydown", (e) => {
      const k = e.key; let n = null;
      if (k === "ArrowRight" || k === "ArrowDown") n = index + 1;
      if (k === "ArrowLeft" || k === "ArrowUp") n = index - 1;
      if (k === "Home") n = 0;
      if (k === "End") n = tabs.length - 1;
      if (n !== null) { e.preventDefault(); select(n, { manual: true, focus: true }); }
    });
    tabList.addEventListener("animationend", (e) => {
      if (e.animationName === "wvDropFill" && running()) select(index + 1);
    });
    if (pauseBtn) pauseBtn.addEventListener("click", () => { auto.user = !auto.user; sync(); });
    root.querySelectorAll(".wv-drop__foot, .wv-hero__bar").forEach((el) => {
      el.addEventListener("mouseenter", () => { if (finePointer.matches) { auto.hover = true; sync(); } });
      el.addEventListener("mouseleave", () => { auto.hover = false; sync(); });
    });
    root.addEventListener("focusin", () => { auto.focus = true; sync(); });
    root.addEventListener("focusout", (e) => { if (!root.contains(e.relatedTarget)) { auto.focus = false; sync(); } });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(([en]) => { auto.away = !en.isIntersecting; sync(); }, { threshold: 0.35 }).observe(root);
    }
    document.addEventListener("visibilitychange", () => { auto.away = document.hidden; sync(); });
    reduce.addEventListener && reduce.addEventListener("change", sync);

    root.__wvDeck = { select, panels };
    sync();
  }

  function initAll(scope) { (scope || document).querySelectorAll("[data-waves-deck]").forEach(initDeck); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();

  /* Theme editor: re-initialise on section reload and show the drop being edited. */
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:block:select", (e) => {
    const panel = e.target.closest && e.target.closest(".wv-drop");
    const deck = panel && panel.closest("[data-waves-deck]");
    if (deck && deck.__wvDeck) deck.__wvDeck.select(deck.__wvDeck.panels.indexOf(panel), { manual: true, force: true });
  });
})();

/* Rails, model wall and floor. */
(() => {
  "use strict";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Rails: arrow buttons scroll the row and disable at the ends. */
  function railButtons(rail) {
    const max = rail.scrollWidth - rail.clientWidth - 2;
    $$(`[data-rail="${rail.id}"]`).forEach((b) => { b.disabled = b.dataset.dir === "-1" ? rail.scrollLeft <= 2 : rail.scrollLeft >= max; });
  }
  function initRails(scope) {
    $$(".wv-rail", scope).forEach((rail) => {
      if (rail.__wv) return; rail.__wv = true;
      rail.addEventListener("scroll", () => railButtons(rail), { passive: true });
      railButtons(rail);
    });
  }
  document.addEventListener("click", (e) => {
    const b = e.target.closest && e.target.closest("[data-rail]");
    if (!b) return;
    const rail = document.getElementById(b.dataset.rail);
    if (rail) rail.scrollBy({ left: +b.dataset.dir * rail.clientWidth * 0.8, behavior: reduce.matches ? "auto" : "smooth" });
  });
  window.addEventListener("resize", () => $$(".wv-rail").forEach(railButtons));

  /* Model wall: filter pairs by model number. */
  function initWall(root) {
    if (root.__wv) return; root.__wv = true;
    const btns = $$(".wv-wall__filter button", root);
    const items = $$(".wv-wall__grid [data-model], .wv-wall__grid .wv-card", root);
    const count = root.querySelector("[data-wall-count]");
    const empty = root.querySelector(".wv-wall__empty");
    function apply(v) {
      let n = 0, sold = 0;
      items.forEach((el) => {
        const on = v === "all" || el.dataset.model === v;
        el.hidden = !on;
        if (on) { n++; if (el.classList.contains("is-soldout")) sold++; }
      });
      btns.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.v === v)));
      if (empty) empty.hidden = n > 0;
      if (count) count.textContent = `${n} ${n === 1 ? "pair" : "pairs"} on the wall${sold ? `, ${sold} sold out` : ""}`;
    }
    btns.forEach((b) => b.addEventListener("click", () => apply(b.dataset.v)));
    apply("all");
  }

  /* Floor: department chips, sort and hide sold out, all client-side. */
  function initFloor(root) {
    if (root.__wv) return; root.__wv = true;
    const grid = root.querySelector("[data-floor-grid]");
    const cards = $$(".wv-card", grid);
    const note = grid.querySelector("[data-note]");
    const empty = grid.querySelector("[data-floor-empty]");
    const count = root.querySelector("[data-floor-count]");
    const chips = $$(".wv-chips button", root);
    const hide = root.querySelector("[data-hide-sold]");
    const sort = root.querySelector("[data-sort]");
    const state = { dept: "all", hideSold: false, sort: "new" };
    function apply() {
      const by = {
        new: (a, b) => +b.dataset.created - +a.dataset.created,
        low: (a, b) => +a.dataset.price - +b.dataset.price,
        high: (a, b) => +b.dataset.price - +a.dataset.price,
      }[state.sort];
      const sorted = cards.slice().sort((a, b) => ((a.dataset.available === "false") - (b.dataset.available === "false")) || by(a, b));
      let shown = 0;
      sorted.forEach((c) => {
        const inDept = state.dept === "all" ? c.dataset.pool !== "dept" : (c.dataset.depts || "").split(" ").includes(state.dept);
        const on = inDept && !(state.hideSold && c.dataset.available === "false");
        c.hidden = !on;
        grid.insertBefore(c, empty);
        if (on) shown++;
      });
      if (note) {
        note.hidden = state.dept !== "all";
        const visible = sorted.filter((c) => !c.hidden);
        // Place the two-column note tile after about five cards, at a point where it fits on the row
        const gridCols = getComputedStyle(grid).gridTemplateColumns.split(" ").filter(Boolean).length || 1;
        let at = Math.min(5, visible.length);
        while (at > 0 && at % gridCols > gridCols - Math.min(2, gridCols)) at--;
        if (!note.hidden && visible[at - 1]) visible[at - 1].after(note);
        // The all-departments view should end on a full row: the note tile takes two columns,
        // so trim the last few cards rather than leave a half-empty row
        if (!note.hidden) {
          const cols = getComputedStyle(grid).gridTemplateColumns.split(" ").filter(Boolean).length || 1;
          const extra = (visible.length + Math.min(2, cols)) % cols;
          if (extra && visible.length > cols) {
            visible.slice(-extra).forEach((c) => { c.hidden = true; });
            shown -= extra;
          }
        }
      }
      empty.hidden = shown > 0;
      chips.forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.dept === state.dept)));
      $$("[data-dept-banner]", root).forEach((el) => { el.hidden = el.dataset.deptBanner !== state.dept; });
      const label = state.dept === "all" ? "all departments" : (chips.find((b) => b.dataset.dept === state.dept) || {}).textContent;
      const pool = state.dept === "all" ? cards.filter((c) => c.dataset.pool !== "dept").length : cards.filter((c) => (c.dataset.depts || "").split(" ").includes(state.dept)).length;
      if (count) count.textContent = `Showing ${shown} of ${pool} · ${label}`;
    }
    chips.forEach((b) => b.addEventListener("click", () => { state.dept = b.dataset.dept; apply(); }));
    hide.addEventListener("change", () => { state.hideSold = hide.checked; apply(); });
    sort.addEventListener("change", () => { state.sort = sort.value; apply(); });
    let rt;
    window.addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(apply, 150); });
    apply();
  }

  function initAll(scope) {
    initRails(scope || document);
    $$("[data-waves-wall]", scope || document).forEach(initWall);
    $$("[data-waves-floor]", scope || document).forEach(initFloor);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
})();

/* Pay-later badges. The Trust Badges app (ConversionBear) draws them inside its own frame under
   Add to cart. George asked for them on the left (13 Oct 2026) and directly under the price
   (27 Oct 2026). This moves the app's widget to sit after the price block and adds a small
   stylesheet inside the frame: left alignment and the Waves mono label. Each badge's logo is
   pinned to the left of its slot instead of shifting the row, so no badge is clipped on phones.
   The app's badges, wording and settings are untouched; if the app changes its markup the
   badges fall back to the app's own layout and position. */
(() => {
  const css = () =>
    "@font-face{font-family:'Waves Mono';src:url(" + ((window.WAVES && window.WAVES.monoFont) || "") + ") format('woff2');font-display:swap}" +
    ".trustBarContainer{text-align:left!important;align-items:flex-start!important;padding:2px 0 0!important}" +
    ".trustBarTitle{text-align:left!important;font-family:'Waves Mono',ui-monospace,Menlo,monospace!important;font-size:11px!important;letter-spacing:.05em;text-transform:uppercase;color:#46433e!important;margin:0 0 4px!important}" +
    ".badgesContainer{text-align:left!important;margin-left:0!important}" +
    ".badgeContainer .imageContainer{left:0!important;right:auto!important;transform:translate(0,-50%)!important}";
  const style = (frame) => {
    let doc;
    try { doc = frame.contentDocument; } catch (e) { return false; }
    if (!doc || !doc.head || !doc.querySelector(".trustBarContainer")) return false;
    if (doc.getElementById("wv-trust")) return true;
    const el = doc.createElement("style");
    el.id = "wv-trust";
    el.textContent = css();
    doc.head.appendChild(el);
    return true;
  };
  // Put the widget straight after the price. Moving the frame reloads it from its srcdoc, and the
  // load listener below restyles it.
  const place = () => {
    document.querySelectorAll("#ultimateTrustBadgeswidgetDiv").forEach((w) => {
      if (w.dataset.wvPlaced) return;
      const info = w.closest(".product__information, .product_section, .product-main");
      const price = info && info.querySelector(".product-block--price");
      if (!price) return;
      w.dataset.wvPlaced = "1";
      w.style.margin = "6px 0 18px";
      price.insertAdjacentElement("afterend", w);
    });
  };
  const scan = () => {
    place();
    let done = false;
    document.querySelectorAll("#trust-bar, iframe.widget").forEach((frame) => {
      // A reload or rewrite of the frame's document is invisible to the page observer, so listen on the frame too
      if (!frame.dataset.wvTrust) {
        frame.dataset.wvTrust = "1";
        frame.addEventListener("load", () => style(frame));
      }
      if (style(frame)) done = true;
    });
    return done;
  };
  const start = () => {
    if (!document.querySelector(".product-main, .product_section")) return;
    let n = 0;
    const t = setInterval(() => { if (scan() || ++n > 120) { clearInterval(t); obs.disconnect(); } }, 250);
    const obs = new MutationObserver(scan);
    obs.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* Keyboard access for inherited Flex controls (independent review, 20 Oct 2026): Enter and Space
   on the phone menu toggle, and Escape to close a desktop dropdown opened from the keyboard. */
(() => {
  document.addEventListener("keydown", (e) => {
    const t = e.target;
    if (t && t.matches && t.matches(".mobile-menu__toggle-button") && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      t.click();
    }
  });
  const wire = () => {
    document.querySelectorAll(".header__item.has-mega-menu").forEach((item) => {
      if (item.dataset.wvKbd) return;
      item.dataset.wvKbd = "1";
      const link = item.querySelector(".header__link");
      if (link) { link.setAttribute("aria-haspopup", "true"); link.setAttribute("aria-expanded", "false"); }
      item.addEventListener("focusin", (e) => {
        if (link) link.setAttribute("aria-expanded", String(!item.classList.contains("wv-kbd-closed") || e.target !== link));
        if (e.target !== link) item.classList.remove("wv-kbd-closed");
      });
      item.addEventListener("focusout", (e) => {
        if (!item.contains(e.relatedTarget)) { item.classList.remove("wv-kbd-closed"); if (link) link.setAttribute("aria-expanded", "false"); }
      });
      item.addEventListener("keydown", (e) => {
        if (e.key === "Escape") { item.classList.add("wv-kbd-closed"); if (link) { link.setAttribute("aria-expanded", "false"); link.focus(); } }
      });
    });
  };
  // Flex attaches the mega menus after load, so wire them as they appear
  let n = 0;
  const t = setInterval(() => { wire(); if (++n > 20) clearInterval(t); }, 500);
})();

/* Search Enter safety net (independent review, 20 Oct 2026). After a collection is sorted or
   filtered by AJAX, Flex's and Searchanise's phone search can both stop handling Enter. If
   pressing Enter in a search box does not start a page load, go to the results ourselves. */
(() => {
  let leaving = false;
  window.addEventListener("beforeunload", () => { leaving = true; });
  window.addEventListener("pagehide", () => { leaving = true; });
  document.addEventListener("keydown", (e) => {
    const t = e.target;
    // Header search pop-up only (desktop and phone); Searchanise's own results page is left alone
    if (e.key !== "Enter" || !t || !t.matches || !t.matches('.search-popup__form input[name="q"]')) return;
    const q = t.value.trim();
    if (!q) return;
    const before = location.href;
    setTimeout(() => {
      if (leaving || location.href !== before) return;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const action = (t.form && t.form.getAttribute("action")) || root + "search";
      location.href = action + (action.includes("?") ? "&" : "?") + "q=" + encodeURIComponent(q);
    }, 700);
  }, true);
})();
